import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { UsersTradeData } from "./UsersTradeData";

const UserTrades = () => {
  document.title = "Users Trades | mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Users Trades" />
          <UsersTradeData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserTrades;
